import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { PageLoader } from "../../../components/loader/pageLoader";
import { IncomeFormulaItem } from "../../../components/incomeFormulaItem/incomeFormulaItem";
import { cafeButtons } from "./cafeButtons";
import { Button } from "../../../components/button/button";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { ArrowIcon, CopyIcon, DownloadIcon } from "../../../assets/icons";
import { Spring } from "../../../components/spring/spring";
import { ProfileInfo } from "../../../components/profileInfo/profileInfo";
import { useConfirmPopup } from "../../../components/popup/confirmPopup/confirmPopup";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { usePopup } from "../../../components/popup/popup";
import { copyToClipboard } from "../../../utils/copyToClipboard";
import { Image } from "../../../components/image/image";
import { TextInput } from "../../../components/textInput/textInput";
import { NumberInput } from "../../../components/numberInput/numberInput";
import { DEFAULT_ICON } from "../../../config/constants";
import AdminAPI from "../../../api/AdminAPI";
import IncomeAPI from "../../../api/IncomeAPI";
import SuperAdminAPI from "../../../api/SuperAdminAPI";

import styles from "./cafeInfo.module.css";

import { Text } from "../../../components/text/text";

export const CafeInfo = () => {
    const openPage = useOpenPage();

    const { cafeId } = useParams();
    const [loading, setLoading] = useState(0);

    const [cafeInfo, setCafeInfo] = useState({
        name: `Предприятие ${cafeId}`,
        address: `Адрес предприятия ${cafeId}`
    });
    useEffect(() => {
        AdminAPI
            .fetchCafeInfo(cafeId)
            .then(setCafeInfo)
            .catch(console.error)
            .finally(setLoading(prev => prev + 1));
    }, [cafeId]);

    const [averageDaily, setAverageDaily] = useState(0);
    useEffect(() => {
        IncomeAPI
            .fetchAdminAverageDaily(cafeId)
            .then(setAverageDaily)
            .catch(console.error)
            .finally(() => setLoading(prev => prev + 1));
    }, [cafeId]);

    const [adminInfo, setAdminInfo] = useState(null);
    useEffect(() => {
        if (!cafeId) return;
        SuperAdminAPI
            .fetchCafeAdminInfo(cafeId)
            .then(setAdminInfo)
            .catch(console.error)
            .finally(() => setLoading(prev => prev + 1));
    }, [cafeId]);

    useEffect(() => {
        if (!adminInfo?.userId) return;
        AdminAPI
            .fetchUserPhoto(adminInfo.userId)
            .then(res => setAdminInfo(prev => ({ ...prev, photo: res })))
            .catch(console.error);
    }, [adminInfo?.userId]);

    const navigate = useAnimatedNavigate();
    const onDelete = () => {
        SuperAdminAPI
            .deleteCafe(cafeId)
            .then(() => navigate("/superadmin/cafe"))
            .catch(console.error);
    }

    const [Popup, open] = useConfirmPopup(
        "Подтвердите действие",
        "Вы уверены, что хотите удалить предприятие?",
        onDelete
    );

    const [deleteAdminLoading, setDeleteAdminLoading] = useState(false);
    const [AdminPopup, openAdmin, closeAdmin] = usePopup();
    const deleteAdmin = () => {
        setDeleteAdminLoading(true);
        SuperAdminAPI
            .deleteAdmin(cafeId, adminInfo.userId)
            .then(() => {
                setAdminInfo(null);
                closeAdmin();
            })
            .catch(console.error)
            .finally(() => setDeleteAdminLoading(false));
    }



    const [monthlyLoading, setMonthlyLoading] = useState(false);
    const downloadReport = (date) => {
        setMonthlyLoading(true);
        AdminAPI
            .downloadMonthlyReport({ ...date, cafeId })
            .catch(console.error)
            .finally(() => setMonthlyLoading(false));
    }

    const [reportMonth, setReportMonth] = useState(new Date().getMonth() + 1);
    const [reportYear, setReportYear] = useState(new Date().getFullYear());
    const [MonthlyPopup, openMonthlyPopup, closeMonthlyPopup] = usePopup();

    const handleDownloadReport = () => {
        closeMonthlyPopup();
        downloadReport({ month: +reportMonth, year: +reportYear });
    };

    const handleOpenMonthlyPopup = () => {
        openMonthlyPopup();
        setReportMonth(new Date().getMonth() + 1);
        setReportYear(new Date().getFullYear());
    };

    const [inviteLink, setInviteLink] = useState("");
    const [InvitePopup, openInvitePopup, closeInvitePopup] = usePopup();
    const onOpenInvite = () => {
        SuperAdminAPI
            .inviteAdmin(cafeId)
            .then(res => {
                setInviteLink(res);
                openInvitePopup();
            })
            .catch(console.error);
    }

    if (loading < 3) {
        return <PageLoader />
    }

    return (
        <>
            <div className={styles.cafe_info}>
                <Text as="div" variant="h1" className={styles.cafe_name} >{cafeInfo.name}</Text>
                <Text as="div" variant="body" className={styles.cafe_address} >{cafeInfo.address}</Text>
            </div>

            <div className={styles.title_container}>
                <Text as="div" variant="bodyStrong" className={styles.title} >Выручка</Text>
                <div className={styles.income_stats}>
                    <IncomeFormulaItem title="День" value={averageDaily} />
                    <IncomeFormulaItem title="Неделя" value={averageDaily * 7} />
                    <IncomeFormulaItem title="Месяц" value={averageDaily * 30} />
                </div>
            </div>

            <div className={styles.title_container}>
                <Text as="div" variant="bodyStrong" className={styles.title} >Админ</Text>
                {
                    !!adminInfo &&
                    <Button
                        text={<ProfileInfo photo={adminInfo.profilePhotoUrl} name={adminInfo.name || "Администратор"} />}
                        type="secondary"
                        icon={<ArrowIcon />}
                        onClick={openAdmin}
                    />
                }

                {
                    !adminInfo &&
                    <Button
                        text="Пригласить админа в предприятие"
                        type="secondary"
                        icon={<CopyIcon />}
                        onClick={onOpenInvite}
                    />
                }
            </div>

            <div className={styles.title_container}>
                <Text as="div" variant="bodyStrong" className={styles.title} >Действия</Text>
                <div className={styles.cafe_buttons}>
                    {
                        cafeButtons.map(data => (
                            <Button
                                key={data.id}
                                text={data.text}
                                onClick={openPage(data.path)}
                                icon={<ArrowIcon />}
                                type="secondary"
                            />
                        ))
                    }
                </div>
            </div>

            <Button
                text="Получить отчет за месяц"
                type="info"
                disabled={monthlyLoading}
                onClick={handleOpenMonthlyPopup}
                icon={<DownloadIcon width="20" height="20" />}
            />

            <MonthlyPopup>
                <Text as="div" variant="h2" className={styles.popup_title} >Отчет за месяц</Text>

                <div className={styles.row}>
                    <NumberInput
                        withoutTransform
                        label="Месяц"
                        val={reportMonth}
                        setVal={(value) => setReportMonth(value)}
                        error={reportMonth < 1 || reportMonth > 12}
                    />
                    <NumberInput
                        withoutTransform
                        label="Год"
                        val={reportYear}
                        setVal={(value) => setReportYear(value)}
                        error={reportYear < 1000 || reportYear > 9999}
                    />
                </div>

                <div className={styles.row}>
                    <Button
                        text="Отмена"
                        onClick={closeMonthlyPopup}
                        type="hint"
                    />

                    <Button
                        text="Скачать"
                        onClick={handleDownloadReport}
                        disabled={monthlyLoading || reportMonth < 1 || reportMonth > 12 || reportYear < 1000 || reportYear > 9999}
                    />
                </div>
            </MonthlyPopup>

            <Spring />

            <Button
                text="Удалить предприятие"
                type="semi_destructive"
                onClick={open}
            />

            {Popup}

            <AdminPopup>
                <div className={styles.admin_info}>
                    <Image className={styles.admin_icon} width="80px" height="80px" objectFit="cover" src={adminInfo?.profilePhotoUrl || DEFAULT_ICON} />
                    <div className={styles.admin_name_container}>
                        <Text as="div" variant="h3" className={styles.admin_title} size={14}>
                            Админ
                        </Text>
                        <Text as="div" variant="h1" className={styles.admin_name} >
                            {adminInfo?.name || "Администратор"}
                        </Text>
                    </div>
                </div>

                <Button
                    text="Задачи админа"
                    type="hint"
                    onClick={openPage(`adminTasks`)}        
                />

                <Button
                    text="Удалить админа"
                    type="destructive"
                    className={styles.delete_admin}
                    onClick={deleteAdmin}
                    disabled={deleteAdminLoading}
                />
            </AdminPopup>

            <InvitePopup>
                <Text as="div" variant="h3" className={styles.copy_title} size={20} weight={700} lineHeight="1.1">Пригласить админа</Text>
                <div className={styles.copy_block}>
                    <TextInput value={inviteLink} setValue={() => { }} />
                    <Button
                        type="hint"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(inviteLink)}
                    />
                </div>
                <Button
                    text="Закрыть"
                    onClick={closeInvitePopup}
                />
            </InvitePopup>
        </>
    );
} 